import { Trans } from '@lingui/react/macro';

import type { PerioToothData } from '@/modules/claims/freeClaims/insuranceExport/types';

import { PlaqueMobilitySection } from './PlaqueMobilitySection';
import { TeethSection } from './TeethSection';

export const PerioChart = ({
  perioData,
  examDate,
}: {
  perioData: PerioToothData[];
  examDate: string;
}) => {
  const upperTeeth = perioData.slice(0, 16);
  const lowerTeeth = perioData
    .slice(16, 32)
    .sort((a, b) => Number(b.toothNumber) - Number(a.toothNumber));

  return (
    <div className="vai-w-full vai-overflow-x-auto">
      <div className="vai-min-w-[1200px] vai-border-2 vai-border-slate-200 vai-rounded-lg">
        {/* Header */}
        <div className="vai-text-left vai-w-full vai-border-b vai-border-slate-200 vai-bg-slate-100 vai-p-2 vai-text-sm vai-font-semibold vai-rounded-t-lg">
          <h1 className="vai-text-lg vai-font-bold">
            <Trans>Perio Chart</Trans>
          </h1>
        </div>

        <TeethSection teeth={upperTeeth} isUpper={true} examDate={examDate} />
        <PlaqueMobilitySection
          upperTeeth={upperTeeth}
          lowerTeeth={lowerTeeth}
        />
        <TeethSection teeth={lowerTeeth} isUpper={false} />
      </div>
    </div>
  );
};
